export default __webpack_public_path__ + "static/media/gamreeLogo.56026d18.png";